import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { DatePipe, DOCUMENT } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'blog-type02',
  standalone: true,
  imports: [MatIconModule, FuseCardComponent, DatePipe],
  templateUrl: './blog-type02.component.html',
})
export class BlogType02Component implements OnInit, OnDestroy {

  public view: any = {
    pageTitle: 'Our Blogs',
    pageDescription: 'Stories that inspire the traveler within from scenic rail adventures and mountain escapes to sun-drenched island getaways. Explore our latest travel articles, tips, and experiences from across the globe.',
    isLoading: true,
  }

  selectedBlog: any = null;
  private readonly _bodyLockClass = 'overflow-hidden';

  openBlogModal(blog: any): void {
    this._tfmService.log('Read more clicked...')
    this.selectedBlog = blog;
    this._setBodyScrollLock(true);
  }

  closeBlogModal(): void {
    this.selectedBlog = null;
    this._setBodyScrollLock(false);
  }

  constructor(
    public _tfmService: TFMService,
    private _cd: ChangeDetectorRef,
    public dialog: MatDialog,
    private _renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) {

    this._tfmService.getSite()
      .then((res) => {
        this.view.site = res;
        this.view.site.profile = this._tfmService.getSiteProfile(res.profileID);

        const agencyID = res.agencyID;
        const siteID = res.siteID;

        return this._tfmService.getArticles(agencyID, siteID);
      })
      .then((res) => {
        this.view.page = res.content;
        this.view.isLoading = false;
        this._cd.detectChanges();
      })
      .catch((err) => {
        console.error('Error:', err);
        this.view.isLoading = false;
      });

  }

  ngOnInit(): void {
    // this.view.isLoading = true;
  }

  ngOnDestroy(): void {
    this._setBodyScrollLock(false);
  }

  private _setBodyScrollLock(locked: boolean): void {
    const body = this._document?.body;
    if (!body) {
      return;
    }

    if (locked) {
      this._renderer.addClass(body, this._bodyLockClass);
      return;
    }

    this._renderer.removeClass(body, this._bodyLockClass);
  }
}

